export const defaultAlertDuration = 10000;

export type Alert = {
  level: "Info" | "Warning" | "Error" | "Success";
  message: string;
  duration?: number;
  action?: {
    name: string;
    callback: () => void;
  };
};
